import Image from "next/image";

interface SectionHeaderProps {
  title?: string;
  headline?: string;
  text?: string;
  headerIcon?: { asset: { url: string }; alt?: string };
  headlineAs?: "h2" | "h3" | "h4";
  headlineSize?: "h2" | "h3" | "h4";
  maxWidth?: string;
}

function getHeaderIconAlt(headerIcon: SectionHeaderProps["headerIcon"]) {
  if (typeof headerIcon?.alt === "string" && headerIcon.alt.trim().length > 0) {
    return headerIcon.alt;
  }

  if (headerIcon?.asset.url.includes("heart-pixel")) return "TMRW heart icon";
  return "TMRW section icon";
}

export default function SectionHeader({
  title,
  headline,
  text,
  headerIcon,
  headlineAs = "h2",
  headlineSize = "h2",
  maxWidth = "max-w-5xl",
}: SectionHeaderProps) {
  if (!title && !headline) return null;

  const HeadlineTag = headlineAs;

  return (
    <div className="w-full flex flex-col items-start gap-2">
      {headerIcon && (
        <Image
          src={headerIcon.asset.url}
          alt={getHeaderIconAlt(headerIcon)}
          aria-hidden={headerIcon.alt ? undefined : true}
          width={138}
          height={138}
          className="w-[70px] h-[70px] lg:w-[100px] lg:h-[100px] object-contain"
          unoptimized
        />
      )}
      {title && headline && <p className="mono bullet text-left">{title}</p>}
      {title && !headline && <h2 className="mono bullet text-left">{title}</h2>}
      {headline && (
        <HeadlineTag className={`${headlineSize} text-left ${maxWidth}`}>{headline}</HeadlineTag>
      )}
      {text && <p className="text-base max-w-6xl mt-5">{text}</p>}
    </div>
  );
}
